module.exports = __webpack_public_path__ + "img/Flunder_9.8ef76ae1.jpg";